import { Text } from "@nef/core";

import StyledAppHeader from "../../styles/_Header.styles";

const AppHeader = (props: any) => {
  const { children } = props;
  
  const ENVIRONMENT = process.env.REACT_APP_INSTANCE_NAME
  
  return (
    <>
      <StyledAppHeader className="app-header" size={1}>
        <Text className="text">{children}</Text>
        <div className={`watermark watermark__${ENVIRONMENT}`} />
      </StyledAppHeader>
    </>
  );
};

export default AppHeader;
